import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLine',
  props: {
    width: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-[6px] bg-[var(--secondary-color)] rounded",
    style: _normalizeStyle({ width: _ctx.width ? `${_ctx.width}px` : '100%' })
  }, null, 4))
}
}

})